import React from 'react';
import { Image, Gamepad2, Trophy, Target, Dices, Flag, Loader2, Check } from 'lucide-react';
import type { SlotScreenId, ScreenConfig } from '@core/types/slot-screen-generator.types';

const ICON_MAP: Record<SlotScreenId, React.FC<{ size?: number; className?: string }>> = {
  'splash': Image,
  'main-screen': Gamepad2,
  'mega-win': Trophy,
  'free-spin-trigger': Target,
  'free-spin-process': Dices,
  'free-spin-end': Flag,
};

interface ScreenCardProps {
  screen: ScreenConfig;
  isActive: boolean;
  onClick: () => void;
}

function StatusIndicator({ status }: { status: ScreenConfig['status'] }) {
  switch (status) {
    case 'generating':
      return <Loader2 size={8} className="text-blue-400 animate-spin" />;
    case 'has-results':
      return <span className="inline-block w-[6px] h-[6px] rounded-full bg-green-500" />;
    case 'selected':
      return <Check size={10} className="text-green-400" />;
    case 'empty':
    default:
      return <span className="inline-block w-[6px] h-[6px] rounded-full border border-zinc-600" />;
  }
}

export function ScreenCard({ screen, isActive, onClick }: ScreenCardProps) {
  const IconComponent = ICON_MAP[screen.id];

  return (
    <div
      onClick={onClick}
      className={`mx-2 mb-1 px-2 py-2 rounded cursor-pointer transition-colors flex items-center gap-2 ${
        isActive
          ? 'bg-blue-900/30 border border-blue-500/50'
          : 'hover:bg-zinc-800 border border-transparent'
      }`}
    >
      <IconComponent size={14} className={isActive ? 'text-blue-400' : 'text-zinc-500'} />
      <div className="flex-1 min-w-0">
        <div className="text-xs text-zinc-300 font-medium truncate">{screen.name}</div>
      </div>
      <StatusIndicator status={screen.status} />
    </div>
  );
}
